const registerModule = ({ router, storeConfig, module, moduleKey }: any) => {
  if (module.store) {
    storeConfig.registerModule(moduleKey, module.store);
  }
  if (module.router) {
    module.router(router);
  }
};

export default registerModule;
